import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'tf0023',
    ecrans: ['00-2'],
    params: ['id']
});
